import { Action } from '@ngrx/store'
import { isArray, isObject, isString, has } from 'lodash'

export interface Button {
  className?: string
  label?: string
  icon?: string
  action: Action
}

export interface ToastData {
  buttons?: Button[]
  dismissAction?: Action
}

export const isAction = (maybeAction: unknown): maybeAction is Action =>
  isObject(maybeAction) && has(maybeAction, 'type') && isString(maybeAction['type'])

export const isButton = (maybeButton: unknown): maybeButton is Button =>
  isObject(maybeButton) && has(maybeButton, 'action') && isAction(maybeButton['action'])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isToastData = (maybeToastData: any): maybeToastData is ToastData => {
  if (maybeToastData) {
    const { buttons, dismissAction } = maybeToastData
    return (
      maybeToastData &&
      (buttons === undefined || isArray(buttons)) &&
      (dismissAction === undefined || isAction(dismissAction))
    )
  }
  return false
}
